// const BASE_URL = "https://localhost:7231/api/attendance";
// const BASE_URL = "https://patmitracbs.in/api/attendance";

import { BASE_URL } from "../config";

// export const addAttendence = async (attendanceList) => {
//   try {
//     const response = await fetch(`${BASE_URL}/attendance/add-excel`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(attendanceList)
//     });

//     const data = await response.json(); 

//     if (!response.ok) {
//       throw new Error("Failed to add attendance");
//     }
//     return data;
//   } catch (error) {
//     console.error("Error to add attendance:", error);
//     throw error;
//   }
// };


export const addAttendence = async (attendanceList) => {
  try {
    const response = await fetch(`${BASE_URL}/attendance/add-excel`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(attendanceList)
    });

    let data;
    try {
      data = await response.json();
    } catch {
      // fallback if backend sent plain text
      const text = await response.text();
      data = { message: text };
    }

    if (!response.ok) {
      return Promise.reject(data);
    }

    return data;
  } catch (error) {
    console.error("Error to add attendance:", error);
    throw error;
  }
};

export const getAttendanceByMonthYear = async (month, year) => {
  try {
    const response = await fetch(
      `${BASE_URL}/attendance/GetByMonthYear?month=${month}&year=${year}`
      // `https://localhost:7231/api/Attendance/ByMonthYear?month=${month}&year=${year}`
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch attendance for ${month}/${year}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching attendance:", error);
    throw error;
  }
};


export const deleteAttendanceByMonthYear = async (month, year) => {
  try {
    const response = await fetch(
      `${BASE_URL}/attendance/DeleteByMonthYear?month=${month}&year=${year}`,
      { method: "DELETE" }
    );
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || `Failed to delete attendance for ${month}/${year}`);
    }

    return data;
  } catch (error) {
    console.error("Error deleting attendance:", error);
    throw error;
  }
};
